import { useId } from 'react';
import { Check } from 'lucide-react';

export interface CheckboxProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  id?: string;
}

export function Checkbox({
  checked = false,
  onChange,
  label,
  disabled = false,
  id,
}: CheckboxProps) {
  const generatedId = useId();
  const checkboxId = id ?? generatedId;

  return (
    <div className="inline-flex items-center gap-2">
      <button
        type="button"
        role="checkbox"
        aria-checked={checked}
        id={checkboxId}
        disabled={disabled}
        onClick={() => onChange?.(!checked)}
        className={[
          'inline-flex items-center justify-center w-5 h-5 rounded-sm border shrink-0 cursor-pointer',
          'transition-colors duration-150',
          'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary',
          'disabled:bg-disabled-bg disabled:border-border disabled:cursor-not-allowed',
          checked
            ? 'bg-primary border-primary'
            : 'bg-white border-border-strong',
        ]
          .filter(Boolean)
          .join(' ')}
      >
        {checked && (
          <Check
            size={14}
            className="text-primary-foreground"
          />
        )}
      </button>
      {label && (
        <label
          htmlFor={checkboxId}
          className={[
            'text-sm leading-5 text-foreground select-none',
            disabled
              ? 'text-disabled-text cursor-not-allowed'
              : 'cursor-pointer',
          ].join(' ')}
        >
          {label}
        </label>
      )}
    </div>
  );
}
